import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Commit } from '../types';

interface VersionState {
  commits: Commit[];
  selectedCommit: Commit | null;
  compareCommits: [string, string] | null;
  branches: string[];
  currentBranch: string;
  loading: boolean;
}

const initialState: VersionState = {
  commits: [],
  selectedCommit: null,
  compareCommits: null,
  branches: ['main'],
  currentBranch: 'main',
  loading: false,
};

const versionSlice = createSlice({
  name: 'version',
  initialState,
  reducers: {
    setCommits: (state, action: PayloadAction<Commit[]>) => {
      state.commits = action.payload;
    },
    setSelectedCommit: (state, action: PayloadAction<Commit | null>) => {
      state.selectedCommit = action.payload;
    },
    setCompareCommits: (state, action: PayloadAction<[string, string] | null>) => {
      state.compareCommits = action.payload;
    },
    setBranches: (state, action: PayloadAction<string[]>) => {
      state.branches = action.payload;
    },
    setCurrentBranch: (state, action: PayloadAction<string>) => {
      state.currentBranch = action.payload;
    },
    setVersionLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setCommits,
  setSelectedCommit,
  setCompareCommits,
  setBranches,
  setCurrentBranch,
  setVersionLoading,
} = versionSlice.actions;

export default versionSlice.reducer;
